import React from 'react';

type RecordIconButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'aria-label' | 'title'> & {
  label: string;
  tone?: 'neutral' | 'primary' | 'danger';
  children: React.ReactNode;
};

/** Consistent, accessible icon-only action used in compact record summaries. */
export function RecordIconButton({
  label,
  tone = 'neutral',
  className,
  type = 'button',
  children,
  ...props
}: RecordIconButtonProps) {
  return (
    <button
      {...props}
      type={type}
      className={['record-icon-action', `record-icon-action--${tone}`, className].filter(Boolean).join(' ')}
      aria-label={label}
      title={label}
    >
      {children}
    </button>
  );
}

type RecordIconLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'children' | 'aria-label' | 'title'> & {
  label: string;
  tone?: 'neutral' | 'primary' | 'danger';
  children: React.ReactNode;
};

/** The same icon-only action as a link (mailto:, tel:, a page). */
export function RecordIconLink({ label, tone = 'neutral', className, children, ...props }: RecordIconLinkProps) {
  return (
    <a {...props} className={['record-icon-action', `record-icon-action--${tone}`, className].filter(Boolean).join(' ')} aria-label={label} title={label}>
      {children}
    </a>
  );
}

export default RecordIconButton;
